// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__dqQdH","loader-animation":"Loader_loader-animation__PCbF9"};